import { publicAxios as axios } from "../../../config/axios";
import { UseToastOptions } from "@chakra-ui/react";

export interface BroadcastSupplier {
  supplierId: string;
  supplierName: string;
  mobileNumber: string;
}

export async function sendBroadcastQuery(
  suppliers: BroadcastSupplier[],
  toast: (options: UseToastOptions) => void,
  orderNo: string,
): Promise<void> {
  const validSuppliers = suppliers.filter((s) => s.mobileNumber?.trim());

  if (validSuppliers.length === 0) {
    toast({
      title:
        suppliers.length === 0
          ? "No Suppliers Selected"
          : "No Valid Mobile Numbers",
      description:
        suppliers.length === 0
          ? "Please add suppliers to the broadcast list first."
          : "None of the selected suppliers have valid mobile numbers.",
      status: suppliers.length === 0 ? "warning" : "error",
      duration: 4000,
      isClosable: true,
      position: "top",
    });
    return;
  }

  try {
    const payload = {
      intent: "SEND_PART_AVAILABILITY_REQUEST_TO_SUPPLIER",
      intentData: {},
      recipients: validSuppliers.map((supplier) => ({
        $whatsapp: [
          supplier.mobileNumber.startsWith("+")
            ? supplier.mobileNumber
            : `+${supplier.mobileNumber}`,
        ],
        is_transient: true,
        data: {
          supplierName: supplier.supplierName,
        },
      })),
      entityIds: validSuppliers.map((s) => s.supplierId),
      requestId: `SEND_PART_AVAILABILITY_REQUEST_TO_SUPPLIER-enquiryNo:${orderNo}`,
    };
    await axios.post("/v1/suprsend/send", payload, {
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });

    toast({
      title: "Broadcast Sent Successfully",
      description: `Query sent to ${validSuppliers.length} supplier(s).`,
      status: "success",
      duration: 4000,
      isClosable: true,
      position: "top",
    });
  } catch (error: any) {
    console.error("Error sending broadcast:", error);
    toast({
      title: "Broadcast Failed",
      description:
        error.response?.data?.message ||
        error.message ||
        "Failed to send broadcast",
      status: "error",
      duration: 5000,
      isClosable: true,
      position: "top",
    });
    throw error;
  }
}
